import { makeStyles } from "@material-ui/core/styles";
import { useIsAr } from "../../../../Hooks";

export default makeStyles((theme) => {
  const { isAr } = useIsAr(theme.direction);

  return {
    cardWrapper: {
      padding: "20px 16px",
      minWidth: "290px",
      width: "420px",
      height: "306px"
    },
    cardContainer: {
      display: "flex",
      flexDirection: "column",
      alignItems: "center",
      gap: "16px",
    },
    headingContainer: {
      position: "relative",
      display: "flex",
      alignItems: "flex-start",
      gap: "25px",
      width: "100%",
      flexDirection: isAr ? "row-reverse" : "row",
      justifyContent: "center",
    },
    container_MoreIcon: {
      display: "flex",
      position: "absolute",
      justifyContent: "center",
      flexDirection: "column",
      gap: "2px",
      position: "absolute",
      top: "5px",
      ...(isAr ? { left: "12px" , top:'2px'} : { right: "12px" ,top:'2px'}),
    },
    contentContainer: {
      display: "flex",
      flexDirection: "column",
      alignItems: "center",
      gap: "16px",
      width: "100%",
    },
    titleWrapper: {
      display: "flex",
      flexDirection: "column",
      alignItems: "center",
      gap: "6px",
      alignSelf: "stretch",
      borderBottom: `1px solid ${theme.palette.background.gray_200}`,
      paddingBottom: "16px",
    },
    documentNameWrapper: {
      display: "flex",
      alignItems: "center",
      gap: "4px",
    },
    footerContainer: {
      display: "flex",
      gap: "12px",
    },
  };
});
